import FilterConfig, {
    SearchTypes,
    Types,
} from "../../components/FilterMaker/FilterConfig";

export const DeclarationSummaryFilterConfig: FilterConfig = {
    table: "declarationTotal",
    url: "",
    statusCountUrl: "",
    pageSize: 10,
    // dataPath: "response",

    topSectionButtons: [],
    filters: [
        // {
        //     column: "search",
        //     id: "search1",
        //     type: Types.search,
        //     label: "Search",
        //     searchType: SearchTypes.like,
        //     options: [
        //         {
        //             tag: "Policy ID",
        //             value: "policyId",
        //         },
        //     ],
        // },
    ],
};
